<sc-flex>
    {{reference.name}}
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <sc-icon iconClass="fa-trash" (click)="remove()"></sc-icon>
</sc-flex>